// do not use imports in this file!! we are trying to keep lead form bundle js clean

import {getCommonVisualizerType} from "../../../../../config";
import {getCurrentLayout} from "../../../../appLayout";
import {getFeatureFromTheBackendBySku} from "../../../../../api/look-api";

export const fixStringEncoding = (string) => {
  return string && (typeof string === "string")
    ? string
      .replace("â€�", "”")
      .replace("â€", "”")
      .replace("â€™", "’")
      .replace("â€¨", " ")
      .replace("Ã¢â‚¬Â¨", "") // not sure what it is
    : string
}

export const fixWizardItem = (wizardItem, wizardItemIndex, forLeadForm = false, newVisualizerType) => {
  wizardItem.wizardNodes = []; // we don't use them in the visualizer! why do we keep them then
  Object.keys(wizardItem).forEach(property => {
    if (typeof wizardItem[property] === "string") {
      wizardItem[property] = fixStringEncoding(wizardItem[property]);
    }
  });
  if (!wizardItem.name) {
    wizardItem.name = "wizard" + (wizardItemIndex > 0 ? "-" + wizardItemIndex + 1 : "");
  }
  const currentVisType = getCommonVisualizerType(newVisualizerType);
  if (wizardItem.wizardGroups) {
    wizardItem.wizardGroups = wizardItem.wizardGroups.filter(wizGroup => {
      if (!wizGroup.enabled || (wizGroup.hideForCustomers && !document.kvConfig.isBackend)) {
        return false
      }
      if (wizardItem.visualizer === "all") {
        return (wizGroup.groupName === "Room") || !Array.isArray(wizGroup.visibleInVisualizers)
          || !wizGroup.visibleInVisualizers.length || wizGroup.visibleInVisualizers.includes(currentVisType)
      }
      return true
    }).map(wizGroup => {
      if (forLeadForm) {
        //getUrlLeadStepName
        wizGroup.leadStepUrl = wizGroup.leadStep
          ? wizGroup.leadStep.toLowerCase().replace(/ /g,"-")
          : "project"
      }
      if (wizGroup.nodeType === "inputs" && Array.isArray(wizGroup.inputFields)) {
        wizGroup.inputFields = wizGroup.inputFields.filter(inputObject => inputObject.checked)
      }
      Object.keys(wizGroup).forEach(property => {
        if (typeof wizGroup[property] === "string") {
          wizGroup[property] = fixStringEncoding(wizGroup[property]);
        }
      });
      ["featuresIncluded", "featuresExcluded"].forEach(property => {
        if (Array.isArray(wizGroup[property]) && wizGroup[property].length) {
          wizGroup[property] = wizGroup[property].map(excluded => {
            if (excluded && (typeof excluded === "object") && excluded.sharedFeatureName) {
              excluded.sharedFeatureName = excluded.sharedFeatureName
                .trim()
                .toLowerCase()
                .replace('room - ', '')
            }
            return excluded
          })
        }
      });
      return wizGroup
    })
  }
  return wizardItem
}

export const getWizardFeatureAsync = async (feature, groupName) => {
  const layout = getCurrentLayout();
  const featureGroup = layout.getFeatureGroupByGroupName(groupName);
  if (featureGroup) {
    const nameToCompare = feature.sharedFeatureName; //lowercased already
    if (featureGroup.activeFeature && featureGroup.activeFeature.getLowerCasedSharedFeatureName() === nameToCompare) {
      return featureGroup.activeFeature
    }
    const navItems = layout.designNavigationItems({part: featureGroup}, null, "", false, "all");
    for (let i = 0; i < navItems.length; i++) {
      if (navItems[i].part.getLowerCasedSharedFeatureName() === nameToCompare) {
        return navItems[i].part;
      }
    }
  }
  return await getFeatureFromTheBackendBySku(feature.sku || feature.sharedFeatureName, featureGroup ? featureGroup.partId : "");
}
